import { FEATURE_FLAG, type Environment } from '@quipex/core/config';

export const productionFeatureFlags = {
    [FEATURE_FLAG.PackApprovals]: true,
    [FEATURE_FLAG.DocumentPackSuggestions]: false,
    [FEATURE_FLAG.BuildingAccessRequests]: false,
    [FEATURE_FLAG.BuildingIdentificationNumbers]: false,
    [FEATURE_FLAG.QuippyPackActions]: true,
    [FEATURE_FLAG.AppTopBar]: false,
    [FEATURE_FLAG.BuildingIntelligence]: false,
    [FEATURE_FLAG.BuildingIntelligenceDocument]: false,
    [FEATURE_FLAG.BuildingHostContext]: false,
    [FEATURE_FLAG.BuildingAddressContext]: false,
    [FEATURE_FLAG.BuildingDocumentReenrichment]: false,
    [FEATURE_FLAG.BuildingSustainabilityDatapoints]: false,
    [FEATURE_FLAG.GoogleDriveImport]: false,
    [FEATURE_FLAG.ProcoreImport]: false,
    [FEATURE_FLAG._Placeholder]: true,
} satisfies Environment['featureFlags'];
